import { gql } from '@apollo/client';

export const CREATE_TMS_TRANSIT_ROUTE = gql`
    mutation CreateTmsTransitRoute($input: TmsTransitRouteInput!) {
        createTmsTransitRoute(input: $input) {
            id
            originHubId
            destinationHubId
            status
            createdAt
            updatedAt
        }
    }
`;

export interface TmsTransitRouteInput {
    originHubId: string;
    destinationHubId: string;
    status: number;
}

export interface CreateTmsTransitRouteResponse {
    createTmsTransitRoute: {
        id: string;
        originHubId: string;
        destinationHubId: string;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}
